import { render, staticRenderFns } from "./productPrice.vue?vue&type=template&id=6a261f5b&scoped=true&"
import script from "./productPrice.vue?vue&type=script&lang=ts&"
export * from "./productPrice.vue?vue&type=script&lang=ts&"
import style0 from "./productPrice.vue?vue&type=style&index=0&id=6a261f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a261f5b",
  null
  
)

export default component.exports